import { Navigate } from "react-router";
import { getCurrentWeekId, getTodayDayOfWeek } from "@/lib/week-utils";

export function TodayRedirect() {
  const weekId = getCurrentWeekId();
  const today = getTodayDayOfWeek(weekId) ?? "mon";
  return <Navigate to={`/week/${weekId}/${today}`} replace />;
}
